import { render, staticRenderFns } from "./MediaPackages.vue?vue&type=template&id=0326e883&"
import script from "./MediaPackages.vue?vue&type=script&lang=js&"
export * from "./MediaPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports